import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import {
  FaInstagram,
  FaLinkedinIn,
} from 'react-icons/fa';
import useScrollReveal from '../hooks/useScrollReveal';
import './Contact.css';

const socials = [
  { icon: <FaInstagram />, label: 'Instagram', url: 'https://instagram.com/miriamhaart' },
  { icon: <FaLinkedinIn />, label: 'LinkedIn', url: 'https://www.linkedin.com/in/miriam-haart/' },
];

function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [gridRef, gridVisible] = useScrollReveal();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setSubmitted(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setSubmitted(false), 4000);
      })
      .catch(() => {
        setError('Something went wrong. Please try again.');
      })
      .finally(() => {
        setSending(false);
      });
  };

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <h2 className="section-title">
          Get in <span className="gold-accent">Touch</span>
        </h2>
        <p className="section-subtitle">
          For speaking engagements, press inquiries, or collaborations
        </p>

        <div ref={gridRef} className={`contact__grid reveal ${gridVisible ? 'visible' : ''}`}>
          <form className="contact__form" onSubmit={handleSubmit}>
            <div className="contact__form-row">
              <div className="contact__field">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                />
              </div>
              <div className="contact__field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your@email.com"
                />
              </div>
            </div>
            <div className="contact__field">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                required
                value={formData.subject}
                onChange={handleChange}
                placeholder="What's this about?"
              />
            </div>
            <div className="contact__field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                required
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your message..."
              />
            </div>
            {error && <p className="contact__error">{error}</p>}
            <button type="submit" className="btn-primary contact__submit" disabled={sending}>
              {sending ? 'Sending...' : submitted ? 'Message Sent ✓' : 'Send Message'}
            </button>
          </form>

          <div className="contact__sidebar">
            <div className="contact__quote">
              <blockquote>
                "Imperfection is beauty, madness is genius, and it's better to be
                absolutely ridiculous than absolutely boring"
              </blockquote>
              <cite>— Marilyn Monroe</cite>
            </div>

            <div className="contact__socials">
              <h4 className="contact__socials-title">Follow Miriam</h4>
              <div className="contact__social-links">
                {socials.map((s, i) => (
                  <a
                    key={i}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact__social-link"
                    aria-label={s.label}
                    title={s.label}
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
